import HundredBricksAPIError from '../../HundredBricksAPIError';
class VerifyEmailError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('VerifyEmailError', ...args);
    }
}
export default VerifyEmailError;
